import { InfoTextConfigModel, ProductConfigProps } from "models/WebShop";
import { useState } from "react";

const InfoTextConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<InfoTextConfigModel>) => {

    const initialConfig = config?.[0];

    const [infoText, setInfoText] = useState(initialConfig?.text ?? "")

    const handleInputChange = (input:string) => {
        setInfoText(input);
        let newConfig: InfoTextConfigModel = {
                        text: input,
                        crmPublishLineId: initialConfig.crmPublishLineId,
                        crmProductId: initialConfig.crmProductId
                    }
                    handleOnChange([newConfig]);
                    handleFormValidation(true);
    } 

    return <><p className="text-muted">Teksten vises på din bedrifts infoside. 
        Forkortet tekst vises også i din oppføring på resultatsider (ikke i mobilvisning). NB! Linjeskift vil ikke bli bevart. Endringer på kjøpte produkter vil bli behandlet fortløpende før det vises på nett.</p>

        <textarea className="form-control border-primary border-opacity-50 mb-2" id="description" aria-label="Beskrivelse av bedriften" maxLength={1000} onChange={(e) => handleInputChange(e.target.value)} placeholder="Beskriv din bedrifts virksomhet og fordelene ved å velge din bedrift…" style={{overflow: "hidden", resize: "none", height: "300px"}} value={infoText}></textarea>
        <p><small><span id="charCounter">{infoText.length} / 1000</span> tegn</small></p>
    </>

}

export default InfoTextConfig;